import React, {useEffect, useState} from "react";
import './style.less';
import {generateClassName} from "jzfz-web-utils";


export interface CopyBlockProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    className?: string;
    disabled?: boolean; // 允许复制
    children?: any;
}


interface CopyBlockConfigOption {
    disabled?: boolean; // 允许复制
}


// 自定义事件类型
const COPY_EVENT_TYPE = 'copy_config_change';


/**
 * 禁止复制组件全局配置实例
 */
export class CopyBlockConfig {
    // 组件配置
    static option: CopyBlockConfigOption;

    /**
     * 设置配置
     * @param option
     */
    static config(option: CopyBlockConfigOption) {
        CopyBlockConfig.option = {...option};
        const event = new CustomEvent(COPY_EVENT_TYPE, {detail: {...option}});
        document.dispatchEvent(event);
    }


    /**
     * 获取配置
     */
    static getOption(): CopyBlockConfigOption {
        return CopyBlockConfig.option;
    }


    /**
     * 监听配置变更
     * @param fn
     */
    static on(handler: EventListenerOrEventListenerObject) {
        document.addEventListener(COPY_EVENT_TYPE, handler, false)
    }


    /**
     * 卸载监听
     * @param fn
     */
    static off(handler: EventListenerOrEventListenerObject) {
        document.removeEventListener(COPY_EVENT_TYPE, handler, false);
    }
}


/**
 * 禁止复制组件
 * @constructor
 */
const CopyBlock = (props: CopyBlockProps): any => {
    const { className, children, disabled: arrowCopy } = props;
    // 允许复制
    const [disabled, setDisabled] = useState<boolean>(false);


    useEffect(() => {
        // 获取配置
        const { disabled } = CopyBlockConfig.getOption() || {};
        setDisabled(arrowCopy || disabled);

        const handler = (e: any) => {
            const { detail } = e;
            setDisabled(arrowCopy || (detail || {}).disabled);
        };
        // 监听配置变动
        CopyBlockConfig.on(handler);

        return () => {
            CopyBlockConfig.off(handler);
        }
    }, [])


    /**
     * 复制事件
     * @param e
     */
    const copyHandle = (e: any) => {
        if (disabled) {
            return;
        }
        e.preventDefault();
    }


    /**
     * 右键事件
     */
    const contextMenuHandle = (e: any) => {
        if (disabled) {
            return;
        }
        e.preventDefault();
    }


    return (
        <div
            {...props}
            data-copy-forbidden={!disabled}
            className={generateClassName([className, !disabled ? 'copy-block-component-wrap' : ''])}
            onCopy={copyHandle}
            onContextMenu={contextMenuHandle}
        >
            {children}
        </div>
    )
}


export default CopyBlock;
